import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=485fa8f4"
import script from "./EmptyList.vue?vue&type=script&lang=js"
export * from "./EmptyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports